export const COMPANY_FISCAL_MODES = Object.freeze({
  ARCA_INTEGRATED: "arca_integrated",
  MANUAL_EXTERNAL: "manual_external",
  NO_INTEGRATION: "no_integration",
});

export const DEFAULT_COMPANY_FISCAL_MODE =
  COMPANY_FISCAL_MODES.NO_INTEGRATION;

export const COMPANY_FISCAL_MODE_OPTIONS = Object.freeze([
  {
    value: COMPANY_FISCAL_MODES.ARCA_INTEGRATED,
    label: "Facturacion ARCA",
    badge: "Integrada",
    description:
      "Mozzo emitira el comprobante electronico desde el flujo de cobro cuando la conexion fiscal este habilitada.",
    helper:
      "Completa los datos fiscales, delega Facturacion Electronica a MozzoApp y asigna un punto de venta Web Services por sucursal.",
  },
  {
    value: COMPANY_FISCAL_MODES.MANUAL_EXTERNAL,
    label: "Facturacion manual o externa",
    badge: "Externa",
    description:
      "El restaurante factura con un controlador fiscal, otro sistema o de forma manual.",
    helper:
      "Mozzo conservara el pedido y permitira asociar el comprobante emitido por fuera cuando implementemos el circuito fiscal.",
  },
  {
    value: COMPANY_FISCAL_MODES.NO_INTEGRATION,
    label: "Sin integracion fiscal",
    badge: "No integrada",
    description:
      "Mozzo gestiona la operacion, la caja y los reportes sin emitir comprobantes fiscales.",
    helper:
      "La facturacion queda completamente bajo gestion y responsabilidad del restaurante.",
  },
]);

const validCompanyFiscalModes = new Set(
  COMPANY_FISCAL_MODE_OPTIONS.map((option) => option.value)
);

export const normalizeCompanyFiscalMode = (value) => {
  const normalizedValue = `${value || ""}`.trim().toLowerCase();

  return validCompanyFiscalModes.has(normalizedValue)
    ? normalizedValue
    : DEFAULT_COMPANY_FISCAL_MODE;
};

export const getCompanyFiscalModeOption = (value) => {
  const normalizedValue = normalizeCompanyFiscalMode(value);

  return (
    COMPANY_FISCAL_MODE_OPTIONS.find(
      (option) => option.value === normalizedValue
    ) || COMPANY_FISCAL_MODE_OPTIONS[COMPANY_FISCAL_MODE_OPTIONS.length - 1]
  );
};
